<template>
    <div
        class="flex flex-col gap-2 border-t border-t-white border-b border-b-slate-200 last:border-b-0 px-4 py-4 lg:px-8 lg:py-6"
    >
        <div class="flex justify-between items-center gap-2 lg:gap-8">
            <div>
                <div :id="titleId" class="font-extrabold flex items-center">
                    <slot name="title"> </slot>
                </div>

                <div v-if="$slots.description" :id="descriptionId" class="text-sm text-slate-500">
                    <slot name="description"> </slot>
                </div>
            </div>
            <div class="shrink-0">
                <vx-popover arrow hover placement="top">
                    <vx-toggle
                        v-model="model"
                        :disabled="Boolean(props.disabled)"
                        :aria-labelledby="titleId"
                        :aria-describedby="$slots.description ? descriptionId : undefined"
                        size="sm"
                    />
                    <template v-if="typeof props.disabled === 'string'" v-slot:content>
                        <div class="text-center max-w-sm">
                            {{ props.disabled }}
                        </div>
                    </template>
                </vx-popover>
            </div>
        </div>
        <animate-height v-if="$slots.default" :height="model ? 'auto' : 0" :animateOpacity="true">
            <div>
                <slot> </slot>
            </div>
        </animate-height>
    </div>
</template>
<script setup lang="ts">
import { VxPopover, VxToggle } from '@voxie/frontend-components';
import { useId } from 'vue';
import AnimateHeight from '~/components/general/AnimateHeight.vue';

const props = defineProps<{
    disabled?: string | boolean;
}>();

const model = defineModel({ type: Boolean, default: false });

const titleId = useId();
const descriptionId = useId();
</script>
